const WEEKDAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
const DAYS = [
  { label: 'Mon', value: 'MONDAY' },
  { label: 'Tue', value: 'TUESDAY' },
  { label: 'Wed', value: 'WEDNESDAY' },
  { label: 'Thu', value: 'THURSDAY' },
  { label: 'Fri', value: 'FRIDAY' },
];

export function formatSlotTime(t) {
  if (!t) return '';
  return t.slice(0, 5);
}

export function formatSlotDate(d) {
  if (!d) return '';
  // Slice the date part before parsing to avoid UTC timezone shift
  const [year, month, day] = d.slice(0, 10).split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function buildSlotDayLabel(daysOfWeek) {
  if (!daysOfWeek || daysOfWeek.length === 0) return 'Specific Date';
  const allWeekdays =
    WEEKDAYS.every((d) => daysOfWeek.includes(d)) && daysOfWeek.length === WEEKDAYS.length;
  if (allWeekdays) return 'Every Weekday';
  return daysOfWeek.map((d) => DAYS.find((day) => day.value === d)?.label || d).join(', ');
}

export function buildSlotDateLabel(from, to) {
  if (!from && !to) return null;
  const fromStr = formatSlotDate(from);
  const toStr = to ? formatSlotDate(to) : 'Current';
  if (fromStr === toStr) return fromStr;
  return `${fromStr} – ${toStr}`;
}

export function buildOrgSlotLabel(orgSlot) {
  if (!orgSlot?.start_time || !orgSlot?.end_time) return null;
  const timeRange = `${formatSlotTime(orgSlot.start_time)} – ${formatSlotTime(orgSlot.end_time)}`;
  return orgSlot.days_of_week?.length
    ? `${timeRange} on ${buildSlotDayLabel(orgSlot.days_of_week)}`
    : timeRange;
}
